<template>
  <div id="add-event-image">
    <v-card elevation="20" class="document-card">
      <!-- Premium Header -->
      <div class="header-premium">
        <v-container class="pa-0">
          <v-row class="align-center" no-gutters>
            <v-col cols="auto" class="d-flex align-center pa-4">
              <div class="icon-box-header">
                <v-icon size="32" color="white" class="icon-pulse">mdi-file-document</v-icon>
              </div>
              <div class="ml-4">
                <h2 class="title-header mb-1">{{ pageTitle }}</h2>
                <p class="subtitle-header mb-0">Upload event documents and images</p>
              </div>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="auto" class="d-flex align-center pa-4">
              <v-btn icon @click="closePrompt" class="close-btn-header" title="Close dialog">
                <v-icon>mdi-close-circle</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </div>
      <v-sheet
        id="scrolling-techniques-7"
        class="overflow-y-auto content-sheet"
        max-height="650"
      >
        <v-container class="form-container pa-6">
          <v-form
            ref="form1"
            v-model="valid1"
            lazy-validation
            v-on:submit.prevent="submitData"
          >
            <v-card-text class="pa-0">
              <v-container class="pa-0">
                <!-- Document Type Section -->
                <v-row wrap class="mb-6">
                  <v-col cols="12" sm="6" lg="6" md="6">
                    <label class="field-label-doc">
                      <v-icon small class="label-icon-doc">mdi-file-document</v-icon>
                      <span class="text-danger">*</span> Document Type
                    </label>
                    <v-select
                      :reduce="(option) => option.value"
                      :loading="DocumentTypeOptionsLoading"
                      :items="DocumentTypeOptions"
                      :rules="DocumentTypeRules"
                      v-model="DocumentType"
                      required
                      outlined
                      dense
                      class="custom-select"
                      prepend-icon="mdi-folder-open"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" sm="6" lg="6" md="6" v-if="DocumentType != ''">
                    <label class="field-label-doc">
                      <v-icon small class="label-icon-doc">mdi-text-box</v-icon>
                      Description <small> (optional)</small>
                    </label>
                    <v-text-field
                      v-model="EventDescription"
                      :rules="EventDescriptionRules"
                      placeholder="Enter document description"
                      hint="Brief description of the document"
                      required
                      outlined
                      dense
                      class="custom-input"
                      prepend-icon="mdi-pencil"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <!-- Image Upload Section -->
                <v-row wrap v-if="DocumentType != ''" class="mb-6">
                  <v-col cols="12" sm="6" lg="6" md="6">
                    <label class="field-label-doc">
                      <v-icon small class="label-icon-doc">mdi-image-plus</v-icon>
                      <span class="text-danger">*</span> Upload Image
                      <p class="notes-doc">
                        (JPG, PNG only - Max 5MB)
                      </p>
                    </label>
                    <v-file-input
                      :clearable="false"
                      truncate-length="25"
                      accept="image/png, image/jpeg"
                      placeholder="Upload Event Photo"
                      prepend-icon="mdi-cloud-upload"
                      append-outer-icon="mdi-delete"
                      v-model="UploadImage1"
                      @change="addImage(1)"
                      class="file-input-custom"
                    >
                      <template v-slot:append-outer>
                        <v-icon color="#ef5350" @click="deleteImage(1)">
                          mdi-trash-can
                        </v-icon>
                      </template>
                    </v-file-input>
                  </v-col>

                  <!-- Image Edit Options -->
                  <v-col cols="12" sm="6" lg="6" md="6">
                    <label class="field-label-doc">
                      <v-icon small class="label-icon-doc">mdi-pencil-ruler</v-icon>
                      Image Edit Options
                    </label>
                    <div class="actions-container">
                      <v-btn
                        fab
                        small
                        color="#3a67b1"
                        @click.prevent="flip(true, false)"
                        class="edit-btn"
                        title="Flip horizontally"
                      >
                        <v-icon>mdi-flip-h</v-icon>
                      </v-btn>

                      <v-btn
                        fab
                        small
                        color="#0097d7"
                        @click.prevent="flip(false, true)"
                        class="edit-btn"
                        title="Flip vertically"
                      >
                        <v-icon>mdi-flip-v</v-icon>
                      </v-btn>

                      <v-btn
                        fab
                        small
                        color="#56bda3"
                        @click.prevent="rotate(90)"
                        class="edit-btn"
                        title="Rotate right"
                      >
                        <v-icon>mdi-rotate-right</v-icon>
                      </v-btn>

                      <v-btn
                        fab
                        small
                        color="#edbe38"
                        @click.prevent="rotate(-90)"
                        class="edit-btn"
                        title="Rotate left"
                      >
                        <v-icon>mdi-rotate-left</v-icon>
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>

                <!-- Image Preview -->
                <v-row wrap v-if="DocumentType != ''" class="mb-6">
                  <v-col cols="12">
                    <label class="field-label-doc">
                      <v-icon small class="label-icon-doc">mdi-image-preview</v-icon>
                      Image Preview
                    </label>
                    <div class="preview-container">
                      <cropper
                        ref="cropper"
                        :src="MemberImage.ImageUrl"
                        :stencil-props="{
                          handlers: {},
                          movable: false,
                          scalable: false,
                        }"
                        :stencil-size="StencilSize"
                        image-restriction="stencil"
                      />
                    </div>
                  </v-col>
                </v-row>

                <!-- Action Buttons -->
                <v-row wrap v-if="DocumentType != ''" class="mt-6">
                  <v-col align="center" cols="12" md="12">
                    <v-btn
                      @click="closePrompt"
                      class="action-btn-cancel"
                    >
                      <v-icon left>mdi-close-circle</v-icon>
                      Cancel
                    </v-btn>
                    <v-btn
                      :disabled="!valid1"
                      @click.prevent="submitData"
                      :loading="SubmitFlag"
                      class="action-btn-submit"
                    >
                      <v-icon left>mdi-check-circle</v-icon>
                      Add Document
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-form>
        </v-container>
      </v-sheet>
      <v-card-actions>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import Swal from "sweetalert2";

export default {
  mixins: [common],
  components: {},
  props: {
    addRecordPrompt: {
      type: Boolean,
      required: true,
    },
    pageTitle: {
      type: String,
    },
    pageDescription: {
      type: String,
    },
  },
  data() {
    return {
      valid1: true,

      LoadingFlag: false,
      SubmitFlag: false,

      DocumentTypeRules: [(v) => !!v || "Document Type is required"],
      DocumentType: "",
      DocumentTypeOptions: [],
      DocumentTypeOptionsLoading: false,

      EventDescription: "",
      EventDescriptionRules: [],

      UploadImage1: {},
      MemberImage: { src: null },

      StencilSize: { width: 1360, height: 768 },
    };
  },
  computed: {},
  watch: {
    DocumentTypeOptions: function () {
      console.log("watch DocumentTypeOptions");
      this.LoadingFlag = false;
      this.DocumentTypeOptionsLoading = false;
    },
  },
  created() {
    // this.initialize()
  },
  methods: {
    validateForm() {
      console.log("validateForm called");
      this.$refs.form1.validate();
    },
    resetForm() {
      console.log("resetForm called");
      this.$refs.form1.reset();
      this.closePrompt();
    },
    resetValidation() {
      console.log("resetValidation called");
      this.$refs.form1.resetValidation();
    },
    closePrompt(document = {}) {
      console.log("closePrompt called");
      this.$emit("hideAddDocumentRecordPrompt", document);
    },
    refreshPageData() {
      console.log("refreshPageData called");
      this.getDocumentTypeOptions();
    },
    addImage(id) {
      console.log("addImage called");
      console.log({ id });
      switch (id) {
        case 1:
          var file = this.UploadImage1;
          console.log({ file });
          var src = URL.createObjectURL(file);
          console.log({ src });
          if (this.MemberImage.src) {
            URL.revokeObjectURL(this.MemberImage.src);
          }
          var FileType = file.type;
          console.log({ FileType });
          this.MemberImage = {
            ImageName: file.name,
            ImageType: FileType,
            ImageUrl: src,
            UploadedImage: file,
          };
          break;

        default:
          break;
      }
    },
    deleteImage(id) {
      console.log("deleteImage called");
      console.log({ id });
      switch (id) {
        case 1:
          this.MemberImage = {
            ImageName: null,
            ImageType: null,
            ImageUrl: null,
            UploadedImage: null,
          };
          this.UploadImage1 = {};
          break;

        default:
          break;
      }
    },
    cropImage() {
      // get image data for post processing, e.g. upload or setting image src
      this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
    },
    flip(x, y) {
      console.log("flip x=" + x + ", y=" + y);
      this.$refs.cropper.flip(x, y);
    },
    rotate(angle) {
      console.log("rotate=" + angle);
      this.$refs.cropper.rotate(angle);
    },
    getDocumentTypeOptions() {
      console.log("getDocumentTypeOptions called");
      this.DocumentTypeOptionsLoading = true;
      var selectbox1_source = "DocumentType";
      var selectbox1_destination = "DocumentTypeOptions";
      var selectbox1_url = "api/sub-category/options";
      var selectbox1_conditions_array = {
        UserInterface: 1,
        CategoryMainId: 16,
      };
      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
    },
    submitData() {
      console.log("submitData is called");
      var message = "";
      var validate1 = this.$refs.form1.validate();
      console.log("validate1=" + validate1);
      if (validate1) {
        // Get Title details

        var DocumentType = this.DocumentType;
        var index1 = this.DocumentTypeOptions.map((e) => e.value).indexOf(
          DocumentType
        );
        console.log("DocumentType=" + DocumentType + ", index1=" + index1);
        var DocumentTypeName = this.DocumentTypeOptions[index1].text;
        console.log("DocumentTypeName=" + DocumentTypeName);
        const { canvas } = this.$refs.cropper.getResult();
        if (canvas) {
          var file = this.UploadImage1;
          var FileType = file.type;
          var ImageName = file.name;
          console.log({ FileType });
          console.log({ ImageName });
          //   const form = new FormData();
          canvas.toBlob((blob) => {
            // formData.append("ProfilePicture", blob, "logo.png");
            // You can use axios, superagent and other libraries instead here
            var tempData = {
              EventDocumentId: null,
              DocumentFlag: true,
              DocumentTypeId: DocumentType,
              DocumentTypeName: DocumentTypeName,
              DocumentDescription: this.EventDescription,
              ImageType: FileType,
              ImageUrl: canvas.toDataURL(),
              UploadedImage: blob,
              UploadedImageName: ImageName,
              UploadedFile: file,
              action: "",
            };
            console.log({ tempData });
            this.closePrompt(tempData);
            // Perhaps you should add the setting appropriate file format here
          }, FileType);
        } else {
          message += "Kindly select image. ";
          this.toast("error", message, true);
        }
      } else {
        if (validate1 == false) {
          message += "Kindly fill the required fields. ";
        }
        this.toast("error", message, true);
      }
    },
  },
  beforeMount() {
    this.refreshPageData();
  },
};
</script>
<style lang="scss" scoped>
// JCI Color Palette
$navy: #3a67b1;
$aqua: #0097d7;
$gold: #edbe38;
$seaform: #56bda3;
$text-90-black: #414042;
$text-off-black: #0a0f29;
$text-white: #ffffff;
$danger-color: #ef5350;
$light-bg: #f8fafc;

#add-event-image {
  .document-card {
    border-radius: 20px !important;
    overflow: hidden;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15) !important;
    background: linear-gradient(135deg, #ffffff 0%, #f5f9fc 100%) !important;
    border: none !important;
  }

  // ============================================
  // PREMIUM HEADER
  // ============================================
  .header-premium {
    background: linear-gradient(135deg, $aqua 0%, $navy 100%);
    position: relative;
    overflow: hidden;
    box-shadow: 0 12px 40px rgba(58, 103, 177, 0.3);

    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: radial-gradient(circle at 20% 50%, rgba(237, 190, 56, 0.1) 0%, transparent 50%),
        radial-gradient(circle at 80% 80%, rgba(86, 189, 163, 0.1) 0%, transparent 50%);
      pointer-events: none;
    }
  }

  .icon-box-header {
    background: rgba(255, 255, 255, 0.2);
    backdrop-filter: blur(15px);
    border-radius: 16px;
    padding: 12px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
    border: 2px solid rgba(255, 255, 255, 0.3);
    animation: float 4s ease-in-out infinite;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 56px;
    min-height: 56px;
  }

  .title-header {
    font-size: 24px;
    font-weight: 900;
    color: $text-white;
    letter-spacing: 0.6px;
    text-shadow: 1px 1px 4px rgba(0, 0, 0, 0.2);
    margin: 0;
  }

  .subtitle-header {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.9);
    font-weight: 500;
    letter-spacing: 0.3px;
    text-transform: uppercase;
  }

  .close-btn-header {
    background: rgba(255, 255, 255, 0.15) !important;
    border: 2px solid rgba(255, 255, 255, 0.3) !important;
    color: white !important;
    border-radius: 12px;
    transition: all 0.3s ease;

    &:hover {
      background: rgba(255, 255, 255, 0.25) !important;
      transform: scale(1.1);
      box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
    }
  }

  // ============================================
  // CONTENT SHEET
  // ============================================
  .content-sheet {
    background: linear-gradient(135deg, #f5f7fa 0%, #e8f0f7 100%);
  }

  .form-container {
    background: transparent;
  }

  // ============================================
  // FIELD LABELS & INPUTS
  // ============================================
  .field-label-doc {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 12px;
    font-weight: 800;
    color: $navy;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 12px;
  }

  .label-icon-doc {
    color: $aqua;
    font-size: 18px;
  }

  .text-danger {
    color: $danger-color;
    font-weight: 900;
    margin-left: 2px;
  }

  .notes-doc {
    font-size: 11px;
    color: $text-90-black;
    font-weight: 500;
    margin: 4px 0 0 0;
    padding: 0;
  }

  ::v-deep .custom-select,
  ::v-deep .custom-input {
    .v-field__outline {
      border-color: rgba(58, 103, 177, 0.3) !important;
      border-width: 2px !important;
    }

    .v-field:hover .v-field__outline {
      border-color: rgba(58, 103, 177, 0.5) !important;
    }

    .v-field--focused .v-field__outline {
      border-color: $navy !important;
      border-width: 2px !important;
      box-shadow: 0 0 0 3px rgba(58, 103, 177, 0.1);
    }

    .v-field {
      border-radius: 12px;
      background: rgba(255, 255, 255, 0.9);

      input {
        font-size: 14px;
        color: $navy;
      }
    }

    .v-input__prepend {
      color: $aqua !important;
    }
  }

  ::v-deep .file-input-custom {
    .v-field {
      background: linear-gradient(135deg, rgba(255, 255, 255, 0.95) 0%, rgba(240, 248, 255, 0.95) 100%);
      border-radius: 12px;
    }

    .v-field__outline {
      border-color: rgba(0, 151, 215, 0.4) !important;
      border-width: 2px !important;
    }
  }

  // ============================================
  // ACTIONS CONTAINER
  // ============================================
  .actions-container {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
    padding: 10px;
    background: rgba(255, 255, 255, 0.6);
    border-radius: 12px;
    border: 2px dashed rgba(58, 103, 177, 0.2);
  }

  .edit-btn {
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;

    &:hover {
      transform: translateY(-2px) scale(1.05);
      box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15) !important;
    }
  }

  // ============================================
  // PREVIEW CONTAINER
  // ============================================
  .preview-container {
    background: white;
    border-radius: 12px;
    border: 3px solid rgba(58, 103, 177, 0.2);
    padding: 16px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
    min-height: 300px;

    .vue-cropper {
      border-radius: 8px;
      overflow: hidden;
    }
  }

  // ============================================
  // ACTION BUTTONS
  // ============================================
  .action-btn-cancel {
    background: linear-gradient(135deg, #ef5350 0%, #e53935 100%) !important;
    color: $text-white !important;
    font-weight: 800;
    padding: 12px 32px !important;
    border-radius: 10px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    box-shadow: 0 8px 24px rgba(239, 83, 80, 0.3) !important;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    margin: 0 8px;
    font-size: 13px;
    border: none !important;

    &:hover {
      background: linear-gradient(135deg, #e53935 0%, #d32f2f 100%) !important;
      box-shadow: 0 12px 32px rgba(239, 83, 80, 0.4) !important;
      transform: translateY(-2px);
    }
  }

  .action-btn-submit {
    background: linear-gradient(135deg, $navy 0%, $aqua 100%) !important;
    color: $text-white !important;
    font-weight: 800;
    padding: 12px 32px !important;
    border-radius: 10px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    box-shadow: 0 8px 24px rgba(58, 103, 177, 0.3) !important;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    margin: 0 8px;
    font-size: 13px;
    border: none !important;

    &:hover:not(:disabled) {
      background: linear-gradient(135deg, $aqua 0%, $navy 100%) !important;
      box-shadow: 0 12px 32px rgba(58, 103, 177, 0.4) !important;
      transform: translateY(-2px);
    }

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }

  // ============================================
  // ANIMATIONS
  // ============================================
  @keyframes float {
    0%, 100% {
      transform: translateY(0px);
    }
    50% {
      transform: translateY(-8px);
    }
  }

  @keyframes slideDown {
    from {
      opacity: 0;
      transform: translateY(-20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  // ============================================
  // RESPONSIVE
  // ============================================
  @media (max-width: 600px) {
    .title-header {
      font-size: 18px;
    }

    .subtitle-header {
      font-size: 11px;
    }

    .action-btn-submit,
    .action-btn-cancel {
      padding: 10px 24px !important;
      margin: 4px !important;
    }

    .actions-container {
      gap: 6px;
    }

    .edit-btn {
      width: 40px !important;
      height: 40px !important;
    }
  }
}
</style>
    font-family: sans-serif;
  }
}
</style>